import Controller, { OnAfterFetch, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MyChartVaccinesAliases } from '../../codegen';
import { FragmentNames } from '../../codegen';
import { ClickEvent, FetchEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { DeckAPI, FetchAPI } from '@philips-internal/oswald-ui-components';
import UserContext from '../../utils/user-context';
import BaseController from '../BaseController';
import VaccineContext from '../../utils/vaccine-context';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { defaultIfUndefined } from '../../utils/object-utils';
import { cast } from '../../utils/cast-helpers';
import { Inject } from '@odinjs/odin';

interface FetchResponseData {
  applicationDate: string;
  estimatedDate: string;
  read: string;
  sequence: number;
  vaccineName: string;
}
@Controller({ fragment: FragmentNames.MY_CHART_VACCINES })
export default class MyChartVaccinesController extends BaseController {

  @Inject(MyChartVaccinesAliases.DECK_VACCINES)
    deckVaccinesAPI!: DeckAPI;

  @OnAfterFetch(MyChartVaccinesAliases.FETCH_VACCINES)
  handleHospitalAfterFetch(event: FetchEvent): void {
    const data = defaultIfUndefined(event.data, []) as FetchResponseData[];
    const newData = data.map<FetchResponseData>(item => { return { ...item } });

    this.deckVaccinesAPI.setData(cast(defaultIfUndefined(newData, [])));
  }

  @OnMount({ target: [
    MyChartVaccinesAliases.FETCH_VACCINES
  ] })
  handleFetchVaccineLoading(event: MountEvent): void {
    const fetchAPI = event.target as FetchAPI;
    fetchAPI.setParameters({ patientId: UserContext.patientId });
    fetchAPI.forceFetch();
  }

  @OnClick({ target: MyChartVaccinesAliases.MY_CHART_VACCINE_CARD_DECK_VACCINES_MY_CHART_VACCINES})
  handleClickVaccineCard(event: ClickEvent): void {
    const { sequence, vaccineName } = event.value;

    VaccineContext.vaccineName = vaccineName;

    HttpService.post(APPLICATION_ENDPOINTS.POST_MC_VACCINE_READ_DOCUMENT, { vaccineSequence: sequence }, {});

    applicationContext.redirect(APPLICATION_ROUTES.MY_CHART_VACCINE_DETAIL, { sequence: sequence });
  }
}